import React from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { musicServicesByMusicAPIID } from 'fym-shared/src/music-services/allMusicServices';
import { TypedMemo } from '../../common/types';
import { LoadingView } from '../../common/views/LoadingView';
import { useAccountId } from '../../../redux/slices/appInfo/hooks';
import { CatalogScreen } from './CatalogScreen';
import { isReturnPagePortal } from './portalReturn/returnPagePortals';
import { PortalReturnPage } from './portalReturn/PortalReturnPage';

/**
 * The Catalog route. Every call the screen makes is account-scoped, so the
 * screen only mounts once the selected account is known. The route
 * `/catalog/connect/:service` opens the connect of that service (design
 * your-intelligence h4). With `?state=` and a return-page portal (Audiomack) it is the return page
 * of that sign-in (`portalReturn/`).
 */
const CatalogViewComponent: React.FC = () => {
  const accountId = useAccountId();
  const { service } = useParams<{ service?: string }>();
  const [params] = useSearchParams();
  const state = params.get('state');

  if (service !== undefined && isReturnPagePortal(service) && state !== null && state !== '') {
    return (
      <PortalReturnPage
        integrationType={service}
        serviceName={musicServicesByMusicAPIID[service]?.name ?? service}
        state={state}
      />
    );
  }

  if (accountId === null) {
    return <LoadingView />;
  }

  return <CatalogScreen accountId={accountId} connectService={service} />;
};

export const CatalogView = TypedMemo(CatalogViewComponent);
